module.exports = __webpack_public_path__ + "assets/img/100108.124810a1.svg";